import png1 from './1.png';
import png2 from './2.png';
import png3 from './3.png';
import png4 from './4.png';
import png5 from './5.png';
import png6 from './6.png';
import png7 from './7.png';
import png8 from './8.png';
import png9 from './9.png';
import png10 from './10.png';
import gif10 from './10.gif';
import png11 from './11.png';
import gif11 from './11.gif';
import png12 from './12.png';
import png13 from './13.png';
import png14 from './14.png';
import png15 from './15.png';
import png16 from './16.png';


 const wrapUpAssets = {
    '1':{
        primaryImg:png1,
        secondaryImg:'',
        videoUrl:'',
    },
    '2':{
        primaryImg:png2,
        secondaryImg:'',
        videoUrl:'',
    },
    '3':{
        primaryImg:png3,
        secondaryImg:'',
        videoUrl:'',
    },
    '4':{
        primaryImg:png4,
        secondaryImg:'',
        videoUrl:'',
    },
    '5':{
        primaryImg:png5,
        secondaryImg:'',
        videoUrl:'',
    },
    '6':{
        primaryImg:png6,
        secondaryImg:'',
        videoUrl:'',
    },
    '7':{
        primaryImg:png7,
        secondaryImg:'',
        videoUrl:'',
    },
    '8':{
        primaryImg:png8,
        secondaryImg:'',
        videoUrl:'',
    },
    '9':{
        primaryImg:png9,
        secondaryImg:'',
        videoUrl:'',
    },
    '10':{
        primaryImg:png10,
        secondaryImg:gif10,
        videoUrl:'',
    },
    '11':{
        primaryImg:png11,
        secondaryImg:gif11,
        videoUrl:'',
    },
    '12':{
        primaryImg:png12,
        secondaryImg:'',
        videoUrl:'https://s3.amazonaws.com/media-p.slid.es/videos/1525730/gp5cz_sB/slide_12.mp4',
    },
    '13':{
        primaryImg:png13,
        secondaryImg:'',
        videoUrl:'',
    },
    '14':{
        primaryImg:png14,
        secondaryImg:'',
        videoUrl:'',
    },
    '15':{
        primaryImg:png15,
        secondaryImg:'',
        videoUrl:'',
    },
    '16':{
        primaryImg:png16,
        secondaryImg:'',
        videoUrl:'',
    },
}

export { wrapUpAssets }